import { render } from "./ModalPianoFatturazione.vue?vue&type=template&id=31335b3c&ts=true"
import script from "./ModalPianoFatturazione.vue?vue&type=script&lang=ts"
export * from "./ModalPianoFatturazione.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__